import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popper from '@mui/material/Popper';
import type { LucideIcon } from 'lucide-react';
import React, { useEffect, useRef } from 'react';

function Info({
  children,
  icon,
  placement = 'top',
}: {
  children?: React.ReactNode;
  icon: LucideIcon;
  placement:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'left-start'
    | 'left-end'
    | 'right-start'
    | 'right-end';
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const iconButtonRef = useRef<HTMLButtonElement>(null);
  const popperRef = useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        popperRef.current &&
        !popperRef.current.contains(event.target as Node) &&
        iconButtonRef.current &&
        !iconButtonRef.current.contains(event.target as Node)
      ) {
        setAnchorEl(null);
      }
    }

    if (anchorEl) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [anchorEl]);

  return (
    <Box>
      <IconButton
        aria-describedby={id}
        type="button"
        onClick={handleClick}
        ref={iconButtonRef}
      >
        {React.createElement(icon)}
      </IconButton>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        ref={popperRef}
        sx={{ zIndex: 1500 }}
      >
        {children}
      </Popper>
    </Box>
  );
}

export default Info;
